import { lazy } from 'react';

export default lazy(
  () =>
    import(
      /* webpackChunkName: "pricing-admin-view" */
      './Approvals'
    )
);
